export const ADD_AVATARS = 'ADD_AVATARS';



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/avatars/constants.es6